import { render } from "./flightDetails.vue?vue&type=template&id=15089022&scoped=true"
import script from "./flightDetails.vue?vue&type=script&lang=js"
export * from "./flightDetails.vue?vue&type=script&lang=js"

import "./flightDetails.vue?vue&type=style&index=0&id=15089022&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15089022"]])

export default __exports__